import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { BaseService } from '../../../../core/base/base.service';
import { ObjectApiInterface } from '../../../../core/base/interfaces/object-api.interface';
import { AccountChartModel, AccountModel } from '../../../../core/models/account-chart.model';
import { AuthService } from '../../../../core/services/auth.service';

@Injectable({
  providedIn: 'root',
})
export class AccountChartService extends BaseService<AccountChartModel> {
  defaultSort = 'label';

  constructor(
    public http: HttpClient,
    public authService: AuthService,
  ) {
    super(http, 'account-chart', authService);
  }

  addAccount(chartId: string, account: Partial<AccountModel>): Observable<ObjectApiInterface<AccountChartModel>> {
    return this.http.post<ObjectApiInterface<AccountChartModel>>(`${this.baseUrlApi}/${chartId}/addAccount`, account, {
      headers: { 'Error-CRUD': 'CREATE' },
    });
  }

  deleteAccount(chartId: string, code: string): Observable<ObjectApiInterface<AccountChartModel>> {
    return this.http.delete<ObjectApiInterface<AccountChartModel>>(
      `${this.baseUrlApi}/${chartId}/deleteAccount/${code}`,
      { headers: { 'Error-CRUD': 'DELETE' } },
    );
  }

  importAccounts(chartId: string, formData: FormData): Observable<ObjectApiInterface<AccountChartModel>> {
    return this.http.post<ObjectApiInterface<AccountChartModel>>(
      `${this.baseUrlApi}/${chartId}/importAccounts`,
      formData,
      { headers: { 'Error-CRUD': 'IMPORT' } },
    );
  }

  downloadAccountsExcelTemplate(): Observable<ObjectApiInterface<any>> {
    return this.http.get<ObjectApiInterface<any>>(`${this.baseUrlApi}/download-excel-template-accounts`);
  }
}
